var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseButton',{staticClass:"commenting-star",class:{
    'commenting-star--is-starred': _vm.isStarred,
  },attrs:{"disabled":_vm.isDisabled,"type":"icon-septim","data-cy":"commenting-star"},on:{"click":function($event){return _vm.update(!_vm.isStarred)}}},[_c('v-icon',[_vm._v("$"+_vm._s(_vm.isStarred ? 'star-solid' : 'star'))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }